import { IconButton, IconButtonProps, IconName } from '@optimus-web/core';
import { DataTestId } from '@mews-commander/enums';
import { useDialog } from '@mews/framework';
import { DetailedPlatformProfileResult } from '@mews-commander/data-access';
import { DeletePlatformProfileDialog } from './DeletePlatformProfileDialog';

export const DeletePlatformProfileButton = (
    props: Pick<IconButtonProps, 'disabled'> & { data: DetailedPlatformProfileResult }
) => {
    const [{ active, onClose }, openDialog] = useDialog();
    const { data } = props;
    return (
        <>
            <IconButton
                variant="tertiary"
                size="medium"
                icon={IconName.Delete}
                data-test-id={DataTestId.TableActionDelete}
                onClick={openDialog}
                {...props}
                type="submit"
            />
            {active && data && (
                <DeletePlatformProfileDialog
                    platformProfile={data}
                    closeDeleteDialog={onClose}
                    closeDetails={onClose}
                />
            )}
        </>
    );
};
